//imports
import { HashRouter,Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Subscribe from './pages/Subscribe';
import OtpConfirm from './pages/OtpConfirm';
import Topups from './pages/topups/Topups'; 
import TopupCreate from './pages/topups/TopupCreate';
import Play from './pages/play/Play';
import PlayCreate from './pages/play/PlayCreate';
import ErrorBoundary from './components/ErrorBoundary';
import Transactions from './pages/transactions/Transactions';
import Client from './pages/clients/Client';
import ClientCreate from './pages/clients/ClientCreate';
import ClientEdit from './pages/clients/ClientEdit';
import ServiceType from './pages/serviceType/ServiceType';
import ServiceTypeCreate from './pages/serviceType/ServiceTypeCreate';
import ServiceTypeEdit from './pages/serviceType/ServiceTypeEdit';
import SdpService from './pages/sdpService/SdpService';
import SdpServiceCreate from './pages/sdpService/SdpServiceCreate';
import SdpServiceEdit from './pages/sdpService/SdpServiceEdit';
import AppUsers from './pages/appUsers/AppUsers';
import AppUserCreate from './pages/appUsers/AppUserCreate';
import AppUserEdit from './pages/appUsers/AppUserEdit';
import Deposit from './pages/deposit/Deposit';
import DepositCreate from './pages/deposit/DepositCreate';
import DepositEdit from './pages/deposit/DepositEdit';
import Winning from './pages/winning/Winning';
import WinningCreate from './pages/winning/WinningCreate';
import WinningEdit from './pages/winning/WinningEdit';
import InteractiveSms from './pages/interactiveSms/InteractiveSms';
import SmsMessage from './pages/smsMessage/SmsMessage';
import DailyUsers from './pages/dailyUsers/DailyUsers';
import SmsMessageCreate from './pages/smsMessage/SmsMessageCreate';
import Phonebook from './pages/phonebook/Phonebook';
import PhonebookCreate from './pages/phonebook/PhonebookCreate';
import PhonebookEdit from './pages/phonebook/PhonebookEdit';
import Phonebookupload from './pages/phonebookupload/Phonebookupload';
import PhonebookuploadCreate from './pages/phonebookupload/PhonebookuploadCreate';
import PhonebookuploadEdit from './pages/phonebookupload/PhonebookuploadEdit';
import Bulkbroadcast from './pages/bulkbroadcast/Bulkbroadcast';
import BulkbroadcastCreate from './pages/bulkbroadcast/BulkbroadcastCreate';
import BulkbroadcastEdit from './pages/bulkbroadcast/BulkbroadcastEdit';
import Senderid from './pages/senderid/Senderid';
import SenderidCreate from './pages/senderid/SenderidCreate';
import SenderidEdit from './pages/senderid/SenderidEdit';     
import SubscriptionSchedule from './pages/subscriptionSchedule/SubscriptionSchedule';
import SubscriptionScheduleCreate from './pages/subscriptionSchedule/SubscriptionScheduleCreate';
import SubscriptionScheduleEdit from './pages/subscriptionSchedule/SubscriptionScheduleEdit';
import SubscriptionBroadcast from './pages/subscriptionBroadcast/SubscriptionBroadcast';
import SubscriptionBroadcastCreate from './pages/subscriptionBroadcast/SubscriptionBroadcastCreate';
import SubscriptionBroadcastEdit from './pages/subscriptionBroadcast/SubscriptionBroadcastEdit';


function App(){
     return (
         <ErrorBoundary>
             <HashRouter>
                 <Routes>
                    <Route path="/login" element={<Login />}/>
                    <Route path="/otpConfirm" element={<OtpConfirm />}/>
                    <Route path="/subscribe" element={<Subscribe />}/>
                    <Route path="/" element={<Dashboard />}/>
                    <Route path="/topups" element={<Topups />}/>
                    <Route path="/topupCreate" element={<TopupCreate />}/>
                    <Route path="/play" element={<Play />}/>
                    <Route path="/playCreate" element={<PlayCreate />}/>
                    <Route path="/transactions" element={<Transactions />}/>
                    <Route path="/client" element={<Client />}/>
                    <Route path="/clientCreate" element={<ClientCreate />}/>
                    <Route path={`/client/:id/edit`} element={<ClientEdit />}/>
                    <Route path="/serviceType" element={<ServiceType />}/>
                    <Route path="/serviceTypeCreate" element={<ServiceTypeCreate />}/>
                    <Route path={`/serviceType/:id/edit`} element={<ServiceTypeEdit />}/>
                    <Route path="/sdpService" element={<SdpService />}/>
                    <Route path="/sdpServiceCreate" element={<SdpServiceCreate />}/>
                    <Route path={`/sdpService/:id/edit`} element={<SdpServiceEdit />}/>
                    <Route path="/appUsers" element={<AppUsers />}/>
                    <Route path="/dailyUsers" element={<DailyUsers />}/>
                    <Route path="/appUserCreate" element={<AppUserCreate />}/>
                    <Route path={`/appUser/:id/edit`} element={<AppUserEdit />}/>
                    <Route path="/deposit" element={<Deposit />}/>
                    <Route path="/depositCreate" element={<DepositCreate />}/>
                    <Route path={`/deposit/:id/edit`} element={<DepositEdit />}/>
                    <Route path="/winning" element={<Winning />}/>
                    <Route path="/winningCreate" element={<WinningCreate />}/>
                    <Route path={`/winning/:id/edit`} element={<WinningEdit />}/>
                    <Route path="/interactiveSms" element={<InteractiveSms />}/>
                    <Route path="/smsMessage" element={<SmsMessage />}/>
                    <Route path="/smsMessageCreate" element={<SmsMessageCreate />}/>
                    <Route path="/phonebook" element={<Phonebook />}/>
                    <Route path="/phonebookCreate" element={<PhonebookCreate />}/>
                    <Route path={`/phonebook/:id/edit`} element={<PhonebookEdit />}/>
                    <Route path="/phonebookupload" element={<Phonebookupload />}/>
                    <Route path="/phonebookuploadCreate" element={<PhonebookuploadCreate />}/>
                    <Route path={`/phonebookupload/:id/edit`} element={<PhonebookuploadEdit />}/>
                    <Route path="/bulkbroadcast" element={<Bulkbroadcast />}/>
                    <Route path="/bulkbroadcastCreate" element={<BulkbroadcastCreate />}/>
                    <Route path={`/bulkbroadcast/:id/edit`} element={<BulkbroadcastEdit />}/>
                    <Route path="/senderid" element={<Senderid />}/>
                    <Route path="/senderidCreate" element={<SenderidCreate />}/>
                    <Route path={`/senderid/:id/edit`} element={<SenderidEdit />}/>
                    <Route path="/subscriptionSchedule" element={<SubscriptionSchedule />}/>
                    <Route path="/subscriptionScheduleCreate" element={<SubscriptionScheduleCreate />}/>
                    <Route path={`/subscriptionSchedule/:id/edit`} element={<SubscriptionScheduleEdit />}/>
                    <Route path="/subscriptionBroadcast" element={<SubscriptionBroadcast />}/>
                    <Route path="/subscriptionBroadcastCreate" element={<SubscriptionBroadcastCreate />}/>
                    <Route path={`/subscriptionBroadcast/:id/edit`} element={<SubscriptionBroadcastEdit />}/>
                </Routes>
             </HashRouter>
        </ErrorBoundary>
    );
}
export default App;